export default __webpack_public_path__ + "static/media/Barret-M82a1-Remote-10.4f3fa586.jpg";